import { jsx } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import { ButtonIcon } from "../ButtonIcon/ButtonIcon.mjs";
const ActionField = ({
  onAction,
  label = "Action",
  icon,
  id,
  "aria-describedby": ariaDescribedBy,
  "aria-expanded": ariaExpanded,
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledBy,
  disabled
}) => {
  const buttonId = id ?? "actionFieldButton";
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: "span",
      width: "touchable",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "fast",
      cursor: "pointer",
      children: /* @__PURE__ */ jsx(
        ButtonIcon,
        {
          label,
          tone: "secondary",
          variant: "transparent",
          onClick: onAction,
          id: buttonId,
          icon,
          disabled,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy,
          "aria-expanded": ariaExpanded,
          "aria-label": ariaLabel
        }
      )
    }
  );
};
export {
  ActionField
};
